import React, {Suspense} from 'react';
import CenterContentBox from "../Champions/ContentWrapper";
import {Header, Loading} from "../common";
import styled from "styled-components";
import ProContent from "./proContent";
import {ErrorBoundary} from "react-error-boundary";
import BottomStickAd from "../ad/BottomStickAd";

const Wrapper = styled.div`
`;

function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const Pro = () => {
    return (
        <Wrapper>
            <Header/>
            <CenterContentBox disableSponsor={true}>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <Suspense fallback={<Loading/>}>
                        <ProContent status={'pro'}/>
                    </Suspense>
                </ErrorBoundary>
            </CenterContentBox>
            <BottomStickAd/>
        </Wrapper>
    );
};

export default Pro;